module.exports = "/images/vendor/flag-icon-css/flags/4x3/bs.svg?9f8a4eae81ab5bc495dd7fa4f7b26d87";